import { toRefs, computed, h, ref, watch, onMounted, onUpdated, onUnmounted, nextTick, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, Fragment, renderList, createBlock, normalizeStyle, createCommentVNode, withDirectives, vShow, renderSlot, getCurrentInstance, inject, withCtx, provide, reactive, createVNode, createSlots } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { TAB_SELECT_EVENT, INPUT_EVENT, TABS_CONTEXT_KEY } from './utils/constants';
import BScroll from '@better-scroll/core';
import Transition from './transition';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props$1 = {
  /**
   * tab的类型，分别支持一级tab、一级底部面板tab和二级tab
   */
  type: propTypes.string().def('primary'),
  /**
   * tab的对齐类型，支持居中center和left居左
   */
  align: propTypes.string().def('center'),
  /**
   * 选中tab的值，即tab panel的key值
   */
  modelValue: propTypes.oneOfType([propTypes.string(), propTypes.number()]),
  /**
   * 初始选中tab的label值
   */
  defaultTab: propTypes.string().def(''),
  /**
   * 初始选中tab的index值
   */
  defaultIndex: propTypes.number().def(0),
  /**
   * 是否展示navbar的底部下划线
   */
  showSlider: propTypes["boolean"]().def(true),
  /**
   * 底部下划线距底部高度，primary默认8px，primary-half默认6px，secondary默认4px
   */
  sliderBottom: propTypes.number(),
  /**
   * 标签的样式
   */
  navItemStyle: propTypes.object().def({}),
  /**
   * 添加标签方法
   */
  addHandler: propTypes["function"]().def(function () {})
};
var emits = [TAB_SELECT_EVENT, INPUT_EVENT];

var _createComponent$3 = createComponent('tab-bar-item'),
  create$3 = _createComponent$3.create,
  className$3 = _createComponent$3.className;
var script$3 = create$3({
  props: {
    /**
     * tab的类型，分别支持一级tab、一级底部面板tab和二级tab
     */
    type: propTypes.string().def('primary'),
    /**
     * tab的对齐类型，支持居中center和left居左
     */
    align: propTypes.string().def('center'),
    /**
     * 选中的值
     */
    active: propTypes["boolean"]().def(false),
    /**
     * 传入的panel值
     */
    panel: propTypes.object().re(),
    /**
     * 元素宽度，居中显示状态下会使用
     */
    itemWidth: propTypes.string().def('')
  },
  emits: [TAB_SELECT_EVENT],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var _toRefs = toRefs(props),
      panel = _toRefs.panel,
      active = _toRefs.active;
    var label = computed(function () {
      return panel.value.slots.label ? panel.value.slots.label() : panel.value.label;
    });
    var handleClick = function handleClick() {
      emit(TAB_SELECT_EVENT);
    };
    return function () {
      var _class;
      return h('a', {
        "class": (_class = {}, _defineProperty(_class, "".concat(className$3), true), _defineProperty(_class, "".concat(className$3, "-").concat(props.type), true), _defineProperty(_class, "".concat(className$3, "-").concat(props.align), true), _defineProperty(_class, "".concat(className$3, "-active"), active.value), _class),
        style: {
          width: props.itemWidth
        },
        onTap: handleClick
      }, [label.value]);
    };
  }
});

script$3.__file = "components/src/component/tabs/tab-bar-item.vue";

var _TypeToSliderBottom;
var _createComponent$2 = createComponent('tab-bar'),
  create$2 = _createComponent$2.create,
  className$2 = _createComponent$2.className;
/**
 * 不同类型距下方距离的对应关系
 */
var TypeToSliderBottom = (_TypeToSliderBottom = {}, _defineProperty(_TypeToSliderBottom, 'primary', 8), _defineProperty(_TypeToSliderBottom, 'primary-half', 6), _defineProperty(_TypeToSliderBottom, 'secondary', 4), _TypeToSliderBottom);
// 游标的默认宽度为20px
var SLIDER_WIDTH = 20;
var script$2 = create$2({
  props: {
    /**
     * tab的类型，分别支持一级tab、一级底部面板tab和二级tab
     */
    type: propTypes.string().def('primary'),
    /**
     * tab的对齐类型，支持居中center和left居左
     */
    align: propTypes.string().def('center'),
    /**
     * 选中的值
     */
    activeIndex: propTypes.number().def(0),
    /**
     * 传入的panel值
     */
    panels: propTypes.array().def([]),
    /**
     * 是否展示navbar的底部下划线
     */
    showSlider: propTypes["boolean"]().def(true),
    /**
     * 底部下划线距底部高度，primary默认8px，primary-half默认6px，secondary默认4px
     */
    sliderBottom: propTypes.number(),
    /**
     * 标签的样式
     */
    navItemStyle: propTypes.object().def({}),
    /**
     * 添加方法
     */
    addHandler: propTypes["function"]().def(function () {})
  },
  emits: [TAB_SELECT_EVENT],
  components: _defineProperty({}, script$3.name, script$3),
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var _toRefs = toRefs(props),
      panels = _toRefs.panels,
      activeIndex = _toRefs.activeIndex,
      navItemStyle = _toRefs.navItemStyle;
    var tabBarRef = ref(null);
    var wrapperRef = ref(null);
    var scrollerInstance = null;
    // 游标宽度默认固定20px，在切换过程中会变化
    var sliderWidth = ref(SLIDER_WIDTH);
    var sliderOffset = ref(0);
    var scrollable = ref(false);
    var isMaskStartShow = ref(false);
    var isMaskEndShow = ref(true);
    var pageX = ref(0);
    var wrapperWidth = ref(0);
    var contentWidth = ref(0);
    var minItemWidth = ref(0);
    var itemStyle = computed(function () {
      return _objectSpread2({}, navItemStyle.value);
    });
    /**
     * 游标距底部的距离，会根据类型具有默认值，用户可传入
     */
    var sliderBottomCom = computed(function () {
      var middleSize = TypeToSliderBottom[props.type];
      return props.sliderBottom !== undefined ? props.sliderBottom : middleSize;
    });
    /**
     * 游标偏移量的单位，居中方式为百分比%，居左方式为像素px
     */
    var sliderOffsetUnit = computed(function () {
      return props.align === 'center' ? '%' : 'px';
    });
    /**
     * 点击tab事件
     * @param key 选中的标签key
     */
    function onTabClick(id) {
      emit(TAB_SELECT_EVENT, id);
    }
    /**
     * 点击添加tab icon
     */
    function onAddClick() {
      props.addHandler();
    }
    /**
     * 滑动到选中的标签
     * @param index 选中的标签index
     */
    function scrollToItem(index) {
      // 游标宽度默认固定20px，在切换过程中会变化为1.8倍
      sliderWidth.value = SLIDER_WIDTH * 1.8;
      setTimeout(function () {
        // 切换完成后再复原
        sliderWidth.value = SLIDER_WIDTH;
      }, 150);
      setSliderOffset(index);
      nextTick(function () {
        var itemEls = Array.from(tabBarRef.value && tabBarRef.value.children || []);
        scrollerInstance && scrollerInstance.scrollToElement(itemEls[index], 300, true, false);
      });
    }
    /**
     * 计算slider的位置
     */
    function initSlider() {
      setSliderOffset(activeIndex.value);
    }
    /**
     * 初始化scroller
     */
    function initScroller() {
      destroyScroller();
      scrollHandler();
    }
    /**
     * 创建scroller
     */
    function createScroller(el) {
      return new BScroll(el, {
        scrollX: true,
        scrollY: false,
        probeType: 3,
        tap: 'tap'
      });
    }
    /**
     * 更新scroller
     */
    function refreshScroller() {
      if (scrollerInstance) {
        scrollerInstance.off('scroll', maskHandler);
        scrollHandler();
        nextTick(function () {
          pageX.value && maskHandler({
            x: pageX.value
          });
        });
      }
    }
    /**
     * 销毁scroller
     */
    function destroyScroller() {
      if (scrollerInstance) {
        scrollerInstance.destroy();
        scrollerInstance = null;
      }
    }
    /**
     * 监听scroll事件
     */
    function scrollHandler() {
      wrapperWidth.value = wrapperRef.value && wrapperRef.value.getBoundingClientRect().width || 0;
      minItemWidth.value = Math.floor(wrapperWidth.value / 5);
      nextTick(function () {
        contentWidth.value = tabBarRef.value && tabBarRef.value.getBoundingClientRect().width || 0;
        scrollable.value = Math.ceil(wrapperWidth.value - contentWidth.value) < 0;
        if (scrollerInstance) {
          scrollerInstance.refresh();
        } else if (wrapperRef.value) {
          scrollerInstance = createScroller(wrapperRef.value);
        }
        scrollerInstance && scrollerInstance.on('scroll', maskHandler);
      });
    }
    function maskHandler(page) {
      var gap = 10;
      if (page.x < 0 && Math.abs(page.x) > gap) {
        isMaskStartShow.value = true;
      } else {
        isMaskStartShow.value = false;
      }
      if (Math.abs(page.x) > contentWidth.value - wrapperWidth.value - gap) {
        isMaskEndShow.value = false;
      } else {
        isMaskEndShow.value = true;
      }
      // 缓存上一次移动的距离
      pageX.value = page.x;
    }
    /**
     * 设置游标的偏移量
     * @param index 当前选中的tab的索引值
     * 说明：如果是居中方式，则设置为选中前X个的完整宽度 + 当前选中的一半 %
     * 说明：如果是居左方式，则获取当前选中前元素的宽度 + 当前选中的宽度的一半 px
     */
    function setSliderOffset(index) {
      setTimeout(function () {
        if (tabBarRef.value && tabBarRef.value.childNodes) {
          // 由于scroll原因，需要设置偏移量做补全进行对齐
          var beforeLeft = props.align === 'center' ? -8 : -2;
          if (props.align === 'center') {
            beforeLeft = index / panels.value.length * 100 + 1 / panels.value.length * 100 / 2;
          } else {
            var nodeList = tabBarRef.value.querySelectorAll(".".concat(className$2, "-item"));
            if (index !== 0) {
              for (var i = 0; i < index; i++) {
                beforeLeft += nodeList[i].getBoundingClientRect().width;
              }
            }
            beforeLeft += nodeList[index].getBoundingClientRect().width / 2;
          }
          sliderOffset.value = beforeLeft;
        }
      }, 0);
    }
    watch(panels, function () {
      initSlider();
      refreshScroller();
    }, {
      deep: true
    });
    watch(activeIndex, function () {
      initSlider();
      scrollToItem(activeIndex.value);
    });
    onMounted(function () {
      initScroller();
    });
    onUpdated(function () {
      initSlider();
    });
    onUnmounted(function () {
      destroyScroller();
    });
    return {
      className: className$2,
      sliderWidth: sliderWidth,
      sliderOffset: sliderOffset,
      wrapperRef: wrapperRef,
      tabBarRef: tabBarRef,
      scrollable: scrollable,
      isMaskStartShow: isMaskStartShow,
      isMaskEndShow: isMaskEndShow,
      itemStyle: itemStyle,
      sliderBottomCom: sliderBottomCom,
      sliderOffsetUnit: sliderOffsetUnit,
      onTabClick: onTabClick,
      onAddClick: onAddClick,
      // 导出单测使用
      maskHandler: maskHandler,
      refreshScroller: refreshScroller
    };
  }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_tab_bar_item = resolveComponent("sp-tab-bar-item");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createElementVNode("div", {
    "class": normalizeClass(["".concat(_ctx.className, "__ui_wrapper"), _ctx.$slots.right && "".concat(_ctx.className, "__ui_wrapper-icon"), "".concat(_ctx.className, "__ui_wrapper-").concat(_ctx.type)]),
    ref: "wrapperRef"
  }, [createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__itemlist")),
    ref: "tabBarRef"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.panels, function (item, index) {
    return openBlock(), createBlock(_component_sp_tab_bar_item, {
      type: _ctx.type,
      align: _ctx.align,
      panel: item,
      key: item.id,
      active: index === _ctx.activeIndex,
      style: normalizeStyle(_ctx.itemStyle),
      onTabSelect: function onTabSelect($event) {
        return _ctx.onTabClick(item.id);
      },
      "item-width": _ctx.align === 'center' ? "".concat(1 / _ctx.panels.length * 100, "%") : ''
    }, null, 8 /* PROPS */, ["type", "align", "panel", "active", "style", "onTabSelect", "item-width"]);
  }), 128 /* KEYED_FRAGMENT */)), _ctx.showSlider && _ctx.sliderWidth ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__slider")),
    style: normalizeStyle({
      width: "".concat(_ctx.sliderWidth, "px"),
      left: "".concat(_ctx.sliderOffset).concat(_ctx.sliderOffsetUnit),
      bottom: "".concat(_ctx.sliderBottomCom, "px")
    })
  }, null, 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */), _ctx.scrollable ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [withDirectives(createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__mask-start"))
  }, null, 2 /* CLASS */), [[vShow, _ctx.isMaskStartShow]]), withDirectives(createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__mask-end"))
  }, null, 2 /* CLASS */), [[vShow, _ctx.isMaskEndShow && !_ctx.$slots.right]])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true), _ctx.$slots.right ? (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass("".concat(_ctx.className, "__right"))
  }, [withDirectives(createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__right_mask"))
  }, null, 2 /* CLASS */), [[vShow, _ctx.isMaskEndShow]]), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__right_icon")),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onAddClick && _ctx.onAddClick.apply(_ctx, arguments);
    })
  }, [renderSlot(_ctx.$slots, "right")], 2 /* CLASS */)], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script$2.render = render$2;
script$2.__file = "components/src/component/tabs/tab-bar.vue";

var props = {
  /**
   * 标签值
   */
  label: propTypes.string().def(''),
  /**
   * 唯一标识
   */
  id: propTypes.oneOfType([propTypes.string(), propTypes.number()]).re(),
  /**
   * 是否展示切换动画，默认为true
   */
  isAnimated: propTypes["boolean"]().def(true)
};

var _createComponent$1 = createComponent('tab-panel'),
  create$1 = _createComponent$1.create,
  className$1 = _createComponent$1.className;
var script$1 = create$1({
  props: props,
  components: _defineProperty({}, Transition.name, Transition),
  setup: function setup(props) {
    var panelInstance = getCurrentInstance();
    var uid = panelInstance.uid;
    var tabsContext = inject(TABS_CONTEXT_KEY);
    if (!tabsContext) {
      console.log('必须和tab一起使用');
    }
    tabsContext && tabsContext.addPanel(uid, panelInstance);
    var active = computed(function () {
      return tabsContext && tabsContext.activeIndex === tabsContext.panelsMap[uid];
    });
    var transitionName = computed(function () {
      // 如果不需要动画，则没有切换效果
      if (props.isAnimated === false) return '';
      var active = tabsContext && +tabsContext.activeIndex;
      var prev = tabsContext && +tabsContext.prevActiveIndex;
      if (active > prev) {
        return "tabs-transition-slide-left";
      }
      return "tabs-transition-slide-right";
    });
    // 监听label变化
    watch(function () {
      return props.label;
    }, function () {
      tabsContext && tabsContext.updatePanel(uid, panelInstance);
    });
    onUnmounted(function () {
      tabsContext && tabsContext.removePanel(uid, panelInstance);
    });
    return {
      active: active,
      className: className$1,
      transitionName: transitionName
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_transition = resolveComponent("sp-transition");
  return openBlock(), createBlock(_component_sp_transition, {
    name: _ctx.transitionName
  }, {
    "default": withCtx(function () {
      return [withDirectives(createElementVNode("div", {
        "class": normalizeClass(_ctx.className)
      }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), [[vShow, _ctx.active]])];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]);
}

script$1.render = render$1;
script$1.__file = "components/src/component/tab-panel/tab-panel.vue";

var _components;
var _createComponent = createComponent('tabs'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props$1,
  emits: emits,
  components: (_components = {}, _defineProperty(_components, script$2.name, script$2), _defineProperty(_components, script$1.name, script$1), _components),
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var panelsMap = {};
    var _toRefs = toRefs(props),
      modelValue = _toRefs.modelValue,
      defaultTab = _toRefs.defaultTab,
      defaultIndex = _toRefs.defaultIndex;
    var panels = ref([]);
    var activeIndex = computed(function () {
      var index;
      if (modelValue && (typeof modelValue.value === 'number' || typeof modelValue.value === 'string')) {
        index = panels.value.findIndex(function (item) {
          return item.id == modelValue.value;
        });
      } else if (defaultTab.value) {
        index = panels.value.findIndex(function (item) {
          return item.label === defaultTab.value;
        });
      } else {
        index = defaultIndex.value;
      }
      return index < 0 ? 0 : index;
    });
    var prevActiveIndex = ref(activeIndex.value);
    /**
     * 点击tab事件
     */
    function handleClick(id) {
      emit(INPUT_EVENT, id);
      emit(TAB_SELECT_EVENT, id);
    }
    /**
     * 添加标签页
     */
    function addPanel(uid, panel) {
      panels.value.push({
        slots: panel.slots,
        label: panel.props.label,
        id: panel.props.id,
        uid: uid
      });
      panelsMap[uid] = panels.value.length - 1;
    }
    /**
     * 删除标签页
     */
    function removePanel(uid) {
      var index = panels.value.findIndex(function (panel) {
        return panel.uid === uid;
      });
      delete panelsMap[uid];
      panels.value.splice(index, 1);
    }
    /**
     * 更新标签页
     */
    function updatePanel(uid, panel) {
      var index = panels.value.findIndex(function (panel) {
        return panel.uid === uid;
      });
      panels.value.splice(index, 1, {
        slots: panel.slots,
        label: panel.props.label,
        id: panel.props.id,
        uid: uid
      });
    }
    provide(TABS_CONTEXT_KEY, reactive({
      activeIndex: activeIndex,
      prevActiveIndex: prevActiveIndex,
      panelsMap: panelsMap,
      addPanel: addPanel,
      removePanel: removePanel,
      updatePanel: updatePanel
    }));
    watch(activeIndex, function (val, oldVal) {
      prevActiveIndex.value = oldVal;
    });
    return {
      className: className,
      panels: panels,
      activeIndex: activeIndex,
      handleClick: handleClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_tab_bar = resolveComponent("sp-tab-bar");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createVNode(_component_sp_tab_bar, {
    type: _ctx.type,
    align: _ctx.align,
    panels: _ctx.panels,
    activeIndex: _ctx.activeIndex,
    showSlider: _ctx.showSlider,
    sliderBottom: _ctx.sliderBottom,
    navItemStyle: _ctx.navItemStyle,
    addHandler: _ctx.addHandler,
    onTabSelect: _ctx.handleClick
  }, createSlots({
    _: 2 /* DYNAMIC */
  }, [_ctx.$slots.right ? {
    name: "right",
    fn: withCtx(function () {
      return [renderSlot(_ctx.$slots, "right")];
    })
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "align", "panels", "activeIndex", "showSlider", "sliderBottom", "navItemStyle", "addHandler", "onTabSelect"]), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__content ").concat(_ctx.className, "__content-").concat(_ctx.type))
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/tabs/tabs.vue";

var _Tabs = script;

export { _Tabs as default };
